<template>
  <touch-layout>
    <template #header_page_breadcrumb>
      <slot name="header_page_breadcrumb" />
    </template>
    <template #header_page_title>
      <slot name="header_page_title" />
    </template>
    <slot name="menu" />
    <div class="flex flex-col grow">
      <div class="flex flex-col gap-5 p-5 grow bg-gray-200 w-full">
        <loading v-if="loading" :loading="true" class="bg-white p-5 border border-gray h-full" />
        <div
          v-else-if="filteredItems.length > 0" 
          class="bg-white p-5 py-0 border border-gray overflow-y-auto"
          style="flex: 1 1 0; min-height: 200px;"
        >
          <div class="flex flex-col gap-2" style="flex: 1 1 0">
            <table class="table-pattern table-auto border-collapse" style="min-width: 500px;">
              <thead class="sticky top-0 bg-white z-30 w-full">
                <tr>
                  <th class="px-4 py-5 pt-10 text-left">Product</th>
                  <th class="px-4 py-5 pt-10 text-left">Fixed Glass</th>
                  <th class="px-4 py-5 pt-10 text-left">Sash Glass</th>
                  <th class="px-4 py-5 pt-10 text-left" />
                </tr>
              </thead>
              <tbody class="w-full">
                <tr v-for="item in filteredItems" :key="item.id">
                  <td class="px-4 py-2">
                    {{ item.description }}
                  </td>
                  <td class="px-4 py-2">
                    <div class="flex items-center bg-white rounded border overflow-hidden w-40">
                      <input
                        v-model.number="item.sizeGlassFixed"
                        type="number"
                        class="grow p-2 w-24"
                        min="0"
                      >
                      <div class="ml-auto border-l px-2">
                        <span>mm</span>
                      </div>
                    </div>
                  </td>
                  <td class="px-4 py-2">
                    <div class="flex items-center bg-white rounded border overflow-hidden w-40">
                      <input
                        v-model.number="item.sizeGlassSash"
                        type="number"
                        class="grow p-2 w-24"
                        min="0"
                      >
                      <div class="ml-auto border-l px-2">
                        <span>mm</span>
                      </div>
                    </div>
                  </td>
                  <td class="px-4 py-2">
                    <div class="ml-auto flex items-center gap-5">
                      <span class="text-xs opacity-50">{{
                        item.isActive ? 'Enabled' : 'Disabled'
                      }}</span>
                      <div class="relative cursor-pointer" @click.stop="item.isActive = !item.isActive">
                        <div class="w-6 h-3 bg-gray-400 rounded-full shadow-inner" />
                        <div class="switch-toggle" :class="{ _active: item.isActive }" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="bg-white p-5 py-0 border border-gray flex justify-center items-center" style="flex: 1 1 0">
          <span>No items Found.</span>
        </div>
      </div>
      <div class="sticky bottom-0 bg-white text-right p-3 border-t">
        <button
          class="btn btn-action btn-lg"
          :class="{
            'opacity-50 pointer-events-none bg-gray-500 border-gray-500':
              JSON.stringify(items) === JSON.stringify(originalItems),
          }"
          @click="save()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </touch-layout>
</template>

<script>

import { mapStores } from 'pinia'
import { useCustomerStore } from '@/pinia/customer';

export default {
  beforeRouteLeave(to, from, next) {
    if (to.name === 'Error') {
      next()
    } else if (JSON.stringify(this.items) !== JSON.stringify(this.originalItems)) {
      this.alertBox()
        .fire({
          title: 'There are unsaved changes',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Go Back',
          confirmButtonText: 'Continue',
        })
        .then((result) => {
          if (result.value) {
            next()
          }
        })
    } else {
      next()
    }
  },
  data() {
    return {
      items: [],
      originalItems: [],
      loading: true
    };
  },
  computed: {
    ...mapStores(useCustomerStore),
    filteredItems() {
      return this.items.filter(x => !x.delete)
    }
  },
  async created() {
    await this.getItems()
  },
  methods: {
    async getItems() {
      const { products } = await window.touch.GetCatalogueProductsWithClearances(this.customerStore.customer.datasetIds[0])
      this.items = products
      this.items.sort((a, b) => a.description.localeCompare(b.description))
      this.originalItems = JSON.parse(JSON.stringify(this.items));
      this.loading = false
    },
    async save() {
      this.loading = true
      const changedItems = this.getChanged()
      try {
        await window.touch.UpdateCatalogueGlassClearances({
          DatasetId: this.customerStore.customer.datasetIds[0],
          GlassClearances: changedItems
        })
      } catch (error) {
        if (error.status === 400) {
          this.alertBox().fire(error.popUp);
        } else {
          throw error
        }
      }
      await this.getItems()
      this.loading = false
    },
    getChanged() {
      let changeditems = [];
      if (JSON.stringify(this.items) !== JSON.stringify(this.originalItems)) {
        for (let index = 0; index < this.items.length; index += 1) {
          const item = this.items[index]
          const originalItem = this.originalItems.find(x => x.engineId === item.engineId)
          if (JSON.stringify(item) !== JSON.stringify(originalItem)) {
            changeditems.push({
              ProductId: item.engineId,
              isActive: item.isActive,
              SizeGlassFixed: item.sizeGlassFixed,
              SizeGlassSash: item.sizeGlassSash
            });
          }
        }
      }
      return changeditems
    },
  },
};
</script>